import { Injectable, Injector } from "@angular/core";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Capacitor } from "@capacitor/core";
import { CustomToasterComponent } from "../../shared/custom-toaster/custom-toaster.component";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
interface ToastRef {
  ref: OverlayRef;
  position: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  private snackbars: ToastRef[] = [];
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';

  constructor(private overlay: Overlay, private injector: Injector, private messageService: MatSnackBar) {
    switch (Capacitor.getPlatform()) {
      case 'ios':
      case 'android':
        this.verticalPosition = 'bottom';
        this.horizontalPosition = 'center';
        break;
    }
  }

  toastSuccess(message: string) {
    this.messageService.open(message, '', {
      duration: 3000,
      verticalPosition: this.verticalPosition,
      horizontalPosition: this.horizontalPosition,
      panelClass: ['success-snackbar'],
    });
  }

  toastError(message: string) {
    this.messageService.open(message, '', {
      duration: 3000,
      verticalPosition: this.verticalPosition,
      horizontalPosition: this.horizontalPosition,
      panelClass: ['error-snackbar'],
    });
  }

  toastInfo(message: string) {
    this.messageService.open(message, '', {
      duration: 3000,
      verticalPosition: this.verticalPosition,
      horizontalPosition: this.horizontalPosition,
      panelClass: ['info-snackbar'],
    });
  }

  toastWarning(message: string) {
    this.messageService.open(message, '', {
      duration: 3000,
      verticalPosition: this.verticalPosition,
      horizontalPosition: this.horizontalPosition,
      panelClass: ['warning-snackbar'],
    });
  }

  toastWarningWithTitle(title: string, message: string): void {
    const position = this.snackbars.length * 80; // Fixed position

    const overlayRef = this.overlay.create({
      positionStrategy: this.overlay.position().global().right().top(`${position}px`),
      hasBackdrop: false,
    });

    const customInjector = Injector.create({
      providers: [
        { provide: 'TOASTER_DATA', useValue: { title, message, position } },
        { provide: OverlayRef, useValue: overlayRef },
      ],
      parent: this.injector,
    });

    const snackbarPortal = new ComponentPortal(CustomToasterComponent, null, customInjector);
    overlayRef.attach(snackbarPortal);

    this.snackbars.push({ ref: overlayRef, position });

    setTimeout(() => this.closeToast(overlayRef), 5000);
  }

  closeToast(overlayRef: OverlayRef): void {
    this.snackbars = this.snackbars.filter(toast => toast.ref !== overlayRef);
    overlayRef.detach();
    this.snackbars.forEach((toast, index) => {
      const newPosition = index * 80; // New position for each remaining toast
      toast.ref.updatePositionStrategy(
        this.overlay.position().global().right().top(`${newPosition}px`)
      );
    });
  }


  showApiValidationError(response: any) {
    if (response.status === 0) {
      this.toastWarning(response.error || response.message || '');
    } else {
      this.toastError(response.error || response.message || '');
    }
  }
}
